<template>
  <div fluid style="max-width: 100vw">
    <v-responsive height="900px">
      <v-row cols="12" justify="center">
        <p class="head">導入までの流れ</p>
      </v-row>
      <v-row cols="12" justify="center">
        <p class="sub">FLOW</p>
      </v-row>

      <transition name="slide-fade">
        <v-row id="step1" justify="center" class="mt-4" v-show="visible1">
          <v-col cols="3"></v-col>
          <v-col align="left" cols="9">
            <div class="step_icon">
              <img src="../assets/step.svg" width="180px" />
              <span>STEP1</span>
            </div>
            <p class="text">
              必要な情報を
              <br />ヒアリングシートに記入
            </p>
            <ul class="text2">
              <li>申請書類</li>
              <li>よくある質問</li>
              <li>保健事業の紹介</li>
              <li>ｅｔｃ…</li>
            </ul>
          </v-col>
        </v-row>
      </transition>

      <transition name="slide-fade">
        <v-row id="step2" justify="center" class="mt-4" v-show="visible2">
          <v-col cols="5"></v-col>
          <v-col align="left" cols="7">
            <div class="step_icon">
              <img src="../assets/step.svg" width="180px" />
              <span>STEP2</span>
            </div>
            <p class="text">完成物の確認</p>
            <p class="text2">
              Step1の情報を基に約１か月で作成いたします。
              <br />ご確認いただき、ご要望があれば修正します。
            </p>
          </v-col>
        </v-row>
      </transition>

      <transition name="slide-fade">
        <v-row id="step3" justify="center" class="mt-4" v-show="visible3">
          <v-col cols="7"></v-col>
          <v-col align="left" cols="5">
            <div class="step_icon">
              <img src="../assets/step.svg" width="180px" />
              <span>STEP3</span>
            </div>
            <p class="text">納品</p>
            <p class="text2">
              加入員のみなさまに開設をお知らせして
              <br />情報発信を始めましょう！！
            </p>
          </v-col>
        </v-row>
      </transition>
    </v-responsive>
  </div>
</template>

<script>
export default {
  name: "Flow",

  data: () => ({
    visible1: false,
    visible2: false,
    visible3: false,
  }),
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      var step1_el = document.getElementById("step1");
      var top1 = step1_el.getBoundingClientRect().top;
      this.visible1 = top1 < window.innerHeight + 50;

      var step2_el = document.getElementById("step2");
      var top2 = step2_el.getBoundingClientRect().top;
      this.visible2 = top2 < window.innerHeight + 50;

      var step3_el = document.getElementById("step3");
      var top3 = step3_el.getBoundingClientRect().top;
      this.visible3 = top3 < window.innerHeight + 50;
    },
  },
};
</script>

<style scoped>
.head {
  position: relative;
  font-size: 30px;
  letter-spacing: 0.1em;
}

.head:before {
  content: "";
  position: absolute;
  bottom: -10px;
  display: inline-block;
  width: 350px;
  height: 1px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background-color: black;
  border-radius: 2px;
}
.sub {
  color: #808080;
  font-size: 18px;
  letter-spacing: 0.1em;
}
.text {
  margin-top: 20px;
  font-size: 28px;
  letter-spacing: 0.1em;
}
.text2 {
  margin-top: 10px;
  font-size: 18px;
  letter-spacing: 0.1em;
}
.step_icon {
  position: relative;
  width: 80px;
  top: 20px;
  right: 58px;
}
.step_icon span {
  color: white;
  font-size: 20px;
  position: absolute;
  width: 20px;
  top: 10px;
  right: 0px;
}
.slide-fade-enter-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(-100px);
  opacity: 0;
}
</style>
